import notDeleted from '../notDeleted'

// AI-CONTEXT: See docs/features/msi-effect-questionnaire-attach.md
// Een meetstandaard-effect heeft precies één vraagveld, en dat veld zit in
// hooguit één vragenlijst. Toevoegen aan een tweede lijst zou het veld stil
// VERHUIZEN; daarom laat de keuzelijst zien waar het al in zit.

/**
 * @typedef {object} AttachStatus
 * @property {'unknown' | 'free' | 'here' | 'elsewhere'} status - Nog niet bekend (velden laden), los, in de huidige vragenlijst, of in een andere
 * @property {string} questionnaireTitle - Titel van de vragenlijst waar het veld in zit ('' als onbekend of los)
 */

/**
 * @typedef {object} AttachStatusOptions
 * @property {Array<object> | string} fields - Live QuestionnaireFields met `Standard: 'true'` van de tenant ('' zolang niet geladen → status 'unknown')
 * @property {Array<object>} questionnaires - Live Questionnaires van de tenant
 * @property {boolean} questionnairesLoaded - Of de eerste snapshot van Questionnaires binnen is
 * @property {string} currentQuestionnaireId - ID van de vragenlijst waaraan wordt toegevoegd
 */

/**
 * @param {{ID: string}} effect - Een OutputEffects-doc
 * @param {AttachStatusOptions} opts
 * @returns {AttachStatus}
 */
const standardEffectAttachStatus = (effect, { fields, questionnaires, questionnairesLoaded, currentQuestionnaireId }) => {
    // Zolang de velden niet geladen zijn ('' = sentinel van de hook) is 'los'
    // een bewering die we niet kunnen doen — en 'los' zet het vinkje open.
    // AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
    if (!Array.isArray(fields)) return { status: 'unknown', questionnaireTitle: '' }

    const live = fields.filter(notDeleted)
    const attached = live.find((f) =>
        Array.isArray(f.EffectId) && f.EffectId.includes(effect.ID) && f.QuestionnaireID
    )

    if (!attached) return { status: 'free', questionnaireTitle: '' }

    const questionnaire = (questionnaires || []).find((q) => q.ID === attached.QuestionnaireID)
    const questionnaireTitle = questionnaire?.Title || ''

    if (attached.QuestionnaireID === currentQuestionnaireId) return { status: 'here', questionnaireTitle }

    // Geladen én niet gevonden: de lijst is verwijderd of onzichtbaar voor de
    // gebruiker, dus het effect is voor hem gewoon vrij.
    if (questionnairesLoaded && !questionnaire) return { status: 'free', questionnaireTitle: '' }

    return { status: 'elsewhere', questionnaireTitle }
}

export default standardEffectAttachStatus
